import { render, staticRenderFns } from "./DetailTab.vue?vue&type=template&id=a566bd14&scoped=true"
import script from "./DetailTab.vue?vue&type=script&lang=js"
export * from "./DetailTab.vue?vue&type=script&lang=js"
import style0 from "./DetailTab.vue?vue&type=style&index=0&id=a566bd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566bd14",
  null
  
)

export default component.exports